export default __webpack_public_path__ + "static/media/work1.9dbf72b5.png";